export enum ExtAsyncQueueState {
    EXPORT_NEW = 'EXPORT_NEW',
    EXPORT_NEED_CONFIRM = 'EXPORT_NEED_CONFIRM',
    IMPORT_NEW = 'IMPORT_NEW',
    UPDATE = 'UPDATE',
    UPDATE_DEFERRED = 'UPDATE_DEFERRED',
    ERROR = 'ERROR',
    EXPORT_OK = 'EXPORT_OK',
    EXPORT_CANCELLED = 'EXPORT_CANCELLED',
    IMPORT_OK = 'IMPORT_OK',
}
